import { IFrames, IMargin, IPadding } from 'src/interfaces/global';
import { EPosition, EThemeColor } from 'src/styles/theme/utils/enums';
import { addFramesStyles, addMarginStyles, addPaddingStyles, addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledModalBackground = styled.section<{
	isVisible: boolean;
	backgroundColor: EThemeColor;
	position: EPosition.center | EPosition.bottomLeft;
}>`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 900;
	width: 100%;

	border: none;
	background-color: transparent;

	display: flex;
	justify-content: center;
	align-items: center;

	${(p) =>
		p.position === EPosition.bottomLeft
			? `
					justify-content: flex-start;
					align-items: flex-end;
					padding: ${p.theme.spacing.xl};
				`
			: ''}

	will-change: transform, opacity;

	${addTransition()}

	& > div {
		position: relative;
		z-index: 999;
	}

	${(p) => css`
		${addTransition()}
		& > div > ${StyledModalChildrenContainer} {
			background-color: ${p.backgroundColor};
			opacity: 0;
		}
	`}

	${(p) =>
		p.isVisible
			? css`
					background-color: ${p.theme.colors.transparentBlack};
					& > div > ${StyledModalChildrenContainer} {
						opacity: 1;
					}
			  `
			: css`
					background-color: transparent;
					& > div > ${StyledModalChildrenContainer} {
						opacity: 0;
					}
			  `}
`;

export const StyledModalChildrenContainer = styled.div<{ innerBorder?: boolean } & IPadding & IMargin & IFrames>`
	${(p) => css`
		overflow: hidden;

		background-color: ${p.theme.colors.carbon};

		border: 1px solid;
		border-color: ${p.theme.colors.gold};
		border-radius: 3px;

		${p.innerBorder
			? css`
					&:after {
						content: '';
						display: block;
						position: absolute;
						inset: 4px;
						border-radius: 3px;
						border: 1px solid rgba(159, 140, 108, 0.3);
						pointer-events: none;
					}
			  `
			: ''}

		${addPaddingStyles(p)}
		${addMarginStyles(p)}
		${addFramesStyles(p)}
	`}

	${addTransition()}
`;
